var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScienceSubsec2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 190,
    viewBox: "0 0 190 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2726_45520)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 95,
    r: 55,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4832 112.968C91.7041 112.968 91.8832 113.147 91.8832 113.368L91.8825 125.049C91.8824 125.218 91.7773 125.369 91.6172 125.421C90.8925 125.657 90.1238 125.797 89.316 125.797L86.7496 125.8C75.4083 125.8 66.2168 116.605 66.2168 105.268C66.2168 100.902 66.6134 96.7078 67.3229 92.7619C67.357 92.5721 67.5225 92.4346 67.7154 92.4346H79.0504C81.1764 92.4346 82.9004 94.157 82.9004 96.2846V101.019C82.9004 101.24 83.0795 101.419 83.3004 101.419H86.3504C86.5713 101.419 86.7504 101.24 86.7504 101.019V96.2846C86.7504 92.0288 83.2985 88.5853 79.0504 88.5853H68.7329C68.4726 88.5853 68.2822 88.3385 68.3476 88.0865C72.0074 73.9917 80.0144 64.2002 89.316 64.2002C90.1229 64.2002 90.8931 64.3414 91.619 64.5798C91.7786 64.6322 91.8832 64.7831 91.8832 64.9511V73.1846C91.8832 76.7266 89.0119 79.601 85.4668 79.601H80.734C80.5131 79.601 80.334 79.7801 80.334 80.001V83.051C80.334 83.2719 80.5131 83.451 80.734 83.451H85.4668C87.6073 83.451 89.5725 82.7688 91.2124 81.6413C91.4895 81.4508 91.8832 81.6418 91.8832 81.978V108.718C91.8832 108.939 91.7041 109.118 91.4832 109.118H84.1832C80.642 109.118 77.7668 106.246 77.7668 102.702V99.2517C77.7668 99.0308 77.5877 98.8517 77.3668 98.8517H74.3168C74.0959 98.8517 73.9168 99.0308 73.9168 99.2517V102.702C73.9168 107.372 77.0515 111.277 81.3182 112.522C81.4931 112.573 81.6168 112.731 81.6168 112.913V117.701C81.6168 117.922 81.7959 118.101 82.0168 118.101H85.0668C85.2877 118.101 85.4668 117.922 85.4668 117.701V113.368C85.4668 113.147 85.6459 112.968 85.8668 112.968H91.4832ZM106 96.2846C106 94.1563 107.724 92.4346 109.85 92.4346H121.184C121.377 92.4346 121.542 92.5721 121.576 92.7619C122.286 96.7078 122.682 100.902 122.682 105.268C122.682 116.605 113.494 125.8 102.15 125.8L99.584 125.797C98.7771 125.797 98.0069 125.656 97.281 125.418C97.1214 125.366 97.0168 125.215 97.0168 125.047V113.368C97.0168 113.147 97.1959 112.968 97.4168 112.968H104.316C104.537 112.968 104.716 113.147 104.716 113.368V117.701C104.716 117.922 104.895 118.101 105.116 118.101H108.166C108.387 118.101 108.566 117.922 108.566 117.701V112.913C108.566 112.731 108.69 112.573 108.865 112.522C113.132 111.277 116.266 107.372 116.266 102.702V99.2517C116.266 99.0308 116.087 98.8517 115.866 98.8517H112.816C112.595 98.8517 112.416 99.0308 112.416 99.2517V102.702C112.416 106.246 109.542 109.118 106 109.118H97.4168C97.1959 109.118 97.0168 108.939 97.0168 108.718V81.9788C97.0168 81.6425 97.4105 81.4516 97.6876 81.6421C99.3275 82.7696 101.293 83.4517 103.433 83.4517H108.166C108.387 83.4517 108.566 83.2726 108.566 83.0517V80.0017C108.566 79.7808 108.387 79.6017 108.166 79.6017H103.433C99.8889 79.6017 97.0168 76.7273 97.0168 73.1853V64.9511C97.0168 64.7831 97.1214 64.6322 97.281 64.5798C98.0069 64.3414 98.7771 64.2002 99.584 64.2002C108.886 64.2002 116.893 73.9918 120.552 88.0865C120.618 88.3385 120.427 88.5853 120.167 88.5853H109.85C105.601 88.5853 102.15 92.0288 102.15 96.2846V101.019C102.15 101.24 102.329 101.419 102.55 101.419H105.6C105.821 101.419 106 101.24 106 101.019V96.2846Z",
    fill: "url(#paint0_angular_2726_45520)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2726_45520",
    x: 0,
    y: 0,
    width: 190,
    height: 190,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2726_45520"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2726_45520",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_2726_45520",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.499 95) rotate(75.4613) scale(34.2354 31.0176)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "#007DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295705,
    stopColor: "#030972"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557292,
    stopColor: "#88B04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "#FFDF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867719,
    stopColor: "#EB6E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980299,
    stopColor: "#BF1932"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScienceSubsec2);
export default __webpack_public_path__ + "static/media/science_subsec_2.c75895217f55955ac3e4352c0d2a182b.svg";
export { ForwardRef as ReactComponent };